import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ae57329"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "camera-example-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "拍照实例", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "main-info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "故障报修图片需包含铭牌信息、受损部位、事故现场图片信息。", -1))
const _hoisted_7 = { class: "tag-wrap" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "image-wrap" }
const _hoisted_10 = ["src", "onClick"]

import { computed, ref } from 'vue'
import { ImagePreview } from 'vant'
import commonWrap from '@/components/popup/common-wrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'camera-example',
  setup(__props) {

const show = ref(false)
const active = ref(1)
const tags = ref([
  { label: '事故现场', value: 1 },
  { label: '受损部位', value: 2 },
  { label: '铭牌信息', value: 3 },
])
const images = computed(() => {
  if (active.value === 3) {
    return ['https://static.knowledge.xag.cn/img/malfunction-repair/nameplate.jpg']
  } else if (active.value === 2) {
    return [
      'https://static.knowledge.xag.cn/img/malfunction-repair/damage1.jpg',
      'https://static.knowledge.xag.cn/img/malfunction-repair/damage2.jpg',
    ]
  } else if (active.value === 1) {
    return [
      'https://static.knowledge.xag.cn/img/malfunction-repair/scene1.jpg',
      'https://static.knowledge.xag.cn/img/malfunction-repair/scene2.jpg',
      'https://static.knowledge.xag.cn/img/malfunction-repair/scene3.jpg',
    ]
  }
  return []
})

function preview(index: number) {
  ImagePreview({
    images: images.value,
    startPosition: index,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true))
    }, _hoisted_4),
    _createVNode(commonWrap, {
      show: show.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      title: "拍照示例"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                onClick: ($event: any) => (active.value = item.value),
                class: _normalizeClass(active.value === item.value ? 'active' : '')
              }, _toDisplayString(item.label), 11, _hoisted_8))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(images), (item, index) => {
              return (_openBlock(), _createElementBlock("img", {
                key: item,
                src: item,
                onClick: ($event: any) => (preview(index))
              }, null, 8, _hoisted_10))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})